export default "__VITE_PUBLIC_ASSET__b4e56688__"